import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import PropTypes from 'prop-types'
import CircularProgress from '@material-ui/core/CircularProgress'
import './catalogo.css'
import Tooltip from '@material-ui/core/Tooltip'
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';

class ArticuloItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            imageError: false
        };
        this.props.getImgArticulo(this.props.itemArticulo.idArticulo)
    }

    handleOnClickEliminarArticulo = (articulo) => {
        this.setState({

            modalConfirmarEliminacion: true

        })
    }
    handleImageError = () => {
        this.setState({ imageError: true });
    };

    render() {
        const { listaImagenesArticulos } = this.props.itemArticulo;
        const imagenArticulo = listaImagenesArticulos && listaImagenesArticulos.length > 0 && listaImagenesArticulos[0].imagen;
        return (
            this.props.isGenerico
                ?
                <div className='itemArticuloContainer'  >
                    <div className='cardImgContainer'>
                        {imagenArticulo && !this.state.imageError ? (
                            <div className='imageArticuloGenerico'>
                                <img
                                    src={`data:image/ief;base64,${imagenArticulo}`}
                                    onError={this.handleImageError}
                                />
                            </div>
                        ) : (
                            <div className='imageDefault'>
                                <div>
                                    <img src={require('../../images/logoLogin.png')} alt="Producto sin foto" />
                                    <div>Producto sin foto</div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='nombreArticulo'>
                        {this.props.itemArticulo.nombre}
                    </div>
                    <div className='rowButton row'>
                        <div className='btnsCantidad'></div>
                        <div className='containerPrecios'>
                            <span className={`precioLista ${this.props.itemArticulo.precioPromocional ? 'precioTachado' : ''}`}>
                                ${this.props.itemArticulo.precioLista}
                            </span>
                            {this.props.itemArticulo.precioPromocional ?
                                <span className='precioClientazo'>
                                    ${this.props.itemArticulo.precioPromocional}
                                </span>
                                :
                                <span className='precioClientazo'>

                                </span>
                            }
                        </div>
                    </div>
                    {/* BUTTON QUITAR */}

                    {/* Botonera */}
                    <div className="containerBtnsItemArticulo">
                        <Row className="rowBtnsItemArticulo">
                            {this.props.quitarProducto !== undefined && this.props.quitarProducto &&
                                <Col xs className='btnDeshabilitar' onClick={(e) => {
                                    this.props.handleOnClickEliminarArticulo(e, this.props.itemArticulo.idArticulo)
                                }}
                                >
                                    <Tooltip title="Quitar" placement="bottom">
                                        <DeleteIcon className={`noDisponibleBtn`}
                                        />
                                    </Tooltip>
                                </Col>}
                            {this.props.agregarProducto !== undefined && this.props.agregarProducto &&
                                <Col xs className='btnDeshabilitar' onClick={(e) => {
                                    this.props.handleOnClickAgregarArticulo(e, this.props.itemArticulo.idArticulo)
                                }}>
                                    <Tooltip title="Agregar artículo al catálogo" placement="bottom">
                                        <AddIcon className={`noDisponibleBtn`} ></AddIcon>

                                    </Tooltip>
                                </Col>}
                        </Row>
                    </div>


                </div>

                :
                <div className='itemArticuloTextilContainer'
                    onClick={this.props.handleclick.bind(this, this.props.isGenerico, this.props.idSuperRubro, this.props.itemArticulo.idRubro, this.props.itemArticulo.idArticulo)}>

                    {this.props.itemArticulo.listaImagenesArticulos !== undefined && this.props.itemArticulo.listaImagenesArticulos.length > 0 && this.props.itemArticulo.listaImagenesArticulos[0].imagen !== null
                        ?
                        <img alt="" src={`data:image/ief;base64,${this.props.itemArticulo.listaImagenesArticulos[0].imagen}`} className='imagenArticulo' />
                        :
                        <div>
                            <CircularProgress />
                            <div className='nombreItem'>{this.props.itemArticulo.nombre}</div>
                        </div>
                    }
                </div>





        )
    }
}

ArticuloItem.propTypes = {
    itemArticulo: PropTypes.object.isRequired,
    idCatalogo: PropTypes.object.isRequired,
    getImgArticulo: PropTypes.func.isRequired
}

ArticuloItem.defaultProps = {
}

export default ArticuloItem